import { AppState } from 'src/store';

import { ModalReducer } from './reducer';

const activeModal = (state: AppState) => state.modal as ModalReducer<any>;

export const modalSelectors = {
  activeModal,
};
